module.exports = __webpack_public_path__ + "static/media/react1.dadf3d22.jpg";